import * as types from './_actionTypes';

const initialState = {
  systemAnalytics: {
    overview: {
      activeUsers: {
        dailyActiveUsers: 0,
        weeklyActiveUsers: 0,
        monthlyActiveUsers: 0
      },
      enrollmentStats: {
        totalEnrollments: 0,
        activeEnrollments: 0,
        completedEnrollments: 0,
        droppedEnrollments: 0,
        completionRate: '0'
      },
      examStats: {
        totalExams: 0,
        totalAttempts: 0,
        completedAttempts: 0,
        passedAttempts: 0,
        passRate: '0',
        averageScore: 0
      },
      certificateStats: {
        totalIssued: 0,
        approved: 0,
        pending: 0,
        revoked: 0,
        approvalRate: '0'
      },
      averageSessionDuration: 0
    },
    trends: {
      monthlyGrowth: []
    },
    performance: {
      topColleges: [],
      popularCourses: [],
      completionRates: {}
    }
  },
  loading: false,
  exporting: false,
  error: null,
  lastUpdated: null
};

const adminAnalyticsReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.FETCH_SYSTEM_ANALYTICS_REQUEST:
    case types.REFRESH_ANALYTICS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };
    
    case types.FETCH_SYSTEM_ANALYTICS_SUCCESS:
      return {
        ...state,
        loading: false,
        systemAnalytics: action.payload,
        error: null,
        lastUpdated: new Date().toISOString()
      };
    
    case types.FETCH_SYSTEM_ANALYTICS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      };
    
    case types.EXPORT_ANALYTICS_REQUEST:
      return {
        ...state,
        exporting: true,
        error: null
      };
    
    case types.EXPORT_ANALYTICS_SUCCESS:
      return {
        ...state,
        exporting: false,
        error: null
      };
    
    case types.EXPORT_ANALYTICS_FAILURE:
      return {
        ...state,
        exporting: false,
        error: action.payload
      };
    
    default:
      return state;
  }
};

export default adminAnalyticsReducer;